'use client';

import { c as _c } from "react/compiler-runtime";
import { isErrorReported } from '@repo/observability/errors';
import { Button, Icon } from '@repo/ui';
import { Alert } from '@repo/ui/icons';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { logger } from '@/lib/observability/logger';
interface RouteErrorBoundaryProps {
  error: Error & {
    digest?: string;
  };
  reset?: () => void;
  title?: string;
  description?: string;
  homeRoute?: string;
  route?: string;
  showErrorMessage?: boolean;
}
export default function RouteErrorBoundary(t0) {
  const $ = _c(28);
  const {
    error,
    reset,
    title: t1,
    description: t2,
    homeRoute: t3,
    route: t4,
    showErrorMessage: t5
  } = t0;
  const title = t1 === undefined ? "Something went wrong!" : t1;
  const description = t2 === undefined ? "Please try again." : t2;
  const homeRoute = t3 === undefined ? "/" : t3;
  const route = t4 === undefined ? "/" : t4;
  const showErrorMessage = t5 === undefined ? true : t5;
  const router = useRouter();
  let t6;
  let t7;
  if ($[0] !== error || $[1] !== route) {
    t6 = () => {
      if (isErrorReported(error)) {
        return;
      }
      logger.fatal(error, {
        route
      });
    };
    t7 = [error, route];
    $[0] = error;
    $[1] = route;
    $[2] = t6;
    $[3] = t7;
  } else {
    t6 = $[2];
    t7 = $[3];
  }
  useEffect(t6, t7);
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      margin: "0 auto"
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon className="text-foreground size-[24px]" icon={<Alert />} />;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== title) {
    t10 = <div className="gap-xs flex items-center">{t9}<span className="text-title-xs text-foreground">{title}</span></div>;
    $[6] = title;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== description) {
    t11 = <span className="text-foreground mb-lg text-sm">{description}</span>;
    $[8] = description;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== error || $[11] !== showErrorMessage) {
    t12 = showErrorMessage && error.message && <span className="text-foreground mb-lg text-sm">{error.message}</span>;
    $[10] = error;
    $[11] = showErrorMessage;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t12) {
    t13 = <div className="gap-xs flex flex-col items-center">{t11}{t12}</div>;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== reset) {
    t14 = <Button onClick={reset}>Try Again</Button>;
    $[16] = reset;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== homeRoute || $[19] !== router) {
    t15 = <Button onClick={() => router.push(homeRoute)} variant="secondary">Go to home</Button>;
    $[18] = homeRoute;
    $[19] = router;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t14 || $[22] !== t15) {
    t16 = <div className="gap-sm flex flex-row">{t14}{t15}</div>;
    $[21] = t14;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t16) {
    t17 = <div className="gap-lg flex min-h-screen flex-col items-center justify-center p-4" style={t8}>{t10}{t13}{t16}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
}